import { FC } from 'react';
import { AnexoSolicitacaoResumida } from 'model/solicitacao/AnexoSolicitacao';
import { IconeArquivo } from './IconeArquivo';
import { DataTempo } from '../../../component/Tempo/DataTempo';
import styled from 'styled-components';
import { Spacing } from 'styles/theme/Tema';
import { SRText } from 'view/component/ScreenReaderText/ScreenReaderText';
import { BiLinkExternal } from "react-icons/bi";
import { LoadingTexto } from 'view/component/Tipografia/Texto';
import Avatar from 'view/component/Avatar/Avatar';


interface ListaAnexosSolicitacaoProps {
  anexos: AnexoSolicitacaoResumida[]
  isLoading?: boolean
}

export const ListaAnexosSolicitacao: FC<ListaAnexosSolicitacaoProps> = ({anexos, isLoading}) => {
  if (isLoading) {
    return <ListaAnexosSolicitacaoLoading />
  }

  return <Lista>
    {anexos.map(it => <ItemListaAnexoSolicitacao key={it.id} anexo={it} />)}
  </Lista>
}

const ListaAnexosSolicitacaoLoading: FC = () => {
  return <Lista as="div" aria-hidden={true}>
    <ItemListaAnexoSolicitacaoLoading />
    <ItemListaAnexoSolicitacaoLoading />
    <ItemListaAnexoSolicitacaoLoading />
  </Lista>
}

const ItemListaAnexoSolicitacaoLoading: FC = () => {
  return <Item as="span">
    <Icone>
      <Avatar loading={true} />
    </Icone>
    <Legenda>
      <LoadingTexto width={150} />
      <LoadingTexto width={120} />
    </Legenda>
  </Item>
}


interface ItemListaAnexoSolicitacaoProps {
  anexo: AnexoSolicitacaoResumida
}

const ItemListaAnexoSolicitacao: FC<ItemListaAnexoSolicitacaoProps> = ({anexo}) => {
  const reino = 1
  const urlAnexo = `/reinos/${reino}/solicitacoes/${anexo.idSolicitacao}/anexos/${anexo.id}`

  return <Item>
    <Icone>
      <IconeArquivo nome={anexo.nome} />
    </Icone>
    <Legenda>
      <a href={urlAnexo} target="_blank" rel='noopener noreferrer'>{anexo.nome}
        <SRText>(será aberta uma nova aba)</SRText>
        {' '}<IconeLinkExterno aria-hidden={true} title={"Será aberta uma nova aba"} />
      </a>
      <div><SRText>Adicionado em </SRText> <DataTempo data={anexo.dataCriacao}/> </div>
    </Legenda>
  </Item>
}

const Lista = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
`;

const Item = styled.li`
  align-content: stretch;
  display: flex;
  margin-right: ${Spacing.unit * 2}px;
`;

const Icone = styled.div`
  padding: ${Spacing.unit}px ${Spacing.unit}px 0 0;
  margin: 0 auto;
`;

const Legenda = styled.div`
  bottom: 0px;
  padding: ${Spacing.unit/2}px;
`;

const IconeLinkExterno = styled(BiLinkExternal)`
  vertical-align: text-top;
`